import React from 'react'
import * as UI from '@brewlogix/blx-ui'
import { parseProfileIcon } from '../../utils/functions'
import { mapStore } from '../../state/mapStore'

const DistanceDurationWidget: React.FC = () => {
    const routeData = mapStore((state) => state.routeData)
    const profile = mapStore((state) => state.profile)
    return (
        <div className='flex items-center justify-between rounded-sm bg-gray-50 px-4 py-2'>
            <div className='mr-4 flex items-center p-1'>
                <UI.Icon slug={parseProfileIcon(profile)} size='sm' customClasses='mr-2' />
                <p className='whitespace-nowrap text-xs'>{routeData?.distance || '0'} miles</p>
            </div>
            <div className='flex items-center'>
                <UI.Icon slug='HeroIcons.Clock' size='sm' customClasses='mr-2' />
                <p className='whitespace-nowrap text-xs'>
                    {`${routeData?.hours}h ${routeData?.minutes}m`}
                </p>
            </div>
        </div>
    )
}
export default DistanceDurationWidget
